import { Component, effect, ElementRef, input, output, viewChild } from '@angular/core';
import { closeDialog, showModal } from '../dialog';

// Fenetre de confirmation modale (<dialog>), ouverte tant que `open` est vrai.
// Le message est projete ; Echap vaut annulation.
@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.html',
})
export class ConfirmDialog {
  readonly open = input.required<boolean>();
  readonly title = input.required<string>();
  readonly confirmLabel = input.required<string>();
  readonly cancelLabel = input('Annuler');
  readonly busy = input(false);
  readonly confirmed = output<void>();
  readonly cancelled = output<void>();

  private readonly dialog = viewChild.required<ElementRef<HTMLDialogElement>>('dialog');

  constructor() {
    effect(() => {
      const dialog = this.dialog().nativeElement;
      if (this.open() && !dialog.open) {
        showModal(dialog);
      } else if (!this.open() && dialog.open) {
        closeDialog(dialog);
      }
    });
  }

  protected onEscape(event: Event): void {
    event.preventDefault();
    this.cancelled.emit();
  }
}
